import BrandMark from "./BrandMark.jsx";
import { Banner, LoadingState } from "./Primitives.jsx";

export default function WorkspaceStatus({ title, error, onRetry, children }) {
  return (
    <main className="workspace-status">
      <div className="workspace-status-card">
        <div className="workspace-brand"><BrandMark /><span>Pakka Paisa</span></div>
        {error ? (
          <>
            <Banner tone="vlow" title={title}>{error}</Banner>
            {onRetry && <button type="button" className="btn primary" onClick={onRetry}>Try again</button>}
          </>
        ) : <LoadingState title={title}>{children}</LoadingState>}
      </div>
    </main>
  );
}
